import { useNavigate } from 'react-router-dom';
import { FURNITURE_VIDEO_URL } from '@pomoshnik/shared';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';
import { VideoButton } from '@/components/VideoButton';

/**
 * Экран 2.5.6 — вход в Блок 5 «Умный фурнитурщик» (ADR-0068, PRD §«Состав блока»).
 *
 * Список из 2 пунктов (вертикально, P-019):
 *   1. «Фурнитура и магазины» — активна → /furniture/search (каталог, 2.5.7).
 *   2. «Умный фурнитурщик» — DISABLED, бейдж «Скоро заработает» (бордовый #8B1538).
 *      Отложенный «умный» проблема→решение пункт (P-029/P-030 — к нему, не к каталогу).
 *
 * VideoButton первым (P-040, entry-экран). Layout shell P-046, back=история P-036.
 * Без async-состояния → single-file (как KindPicker/MethodPicker, ADR-0005).
 */
/** Бордовый бейдж «Скоро заработает» — PRD §«Состав блока». Не из 5 locked-токенов
 *  палитры (P-045 их не запрещает); прецедент — `PaintCardView` RAL-бейдж. */
const BURGUNDY = '#8B1538';

export function FurnitureEntry() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title="Умный фурнитурщик" />

      <div className="flex-1 flex flex-col gap-4 p-6">
        <VideoButton videoUrl={FURNITURE_VIDEO_URL} />

        <button
          type="button"
          onClick={() => navigate('/furniture/search')}
          aria-label="Фурнитура и магазины"
          className={
            'min-h-tap-chip-lg w-full rounded-xl bg-card border-[1.5px] border-accent ' +
            'text-ink font-display text-h2 shadow-card flex items-center justify-center ' +
            'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
          }
          style={{ minHeight: 120 }}
        >
          Фурнитура и магазины
        </button>

        <button
          type="button"
          disabled
          aria-disabled="true"
          aria-label="Умный фурнитурщик (Скоро заработает)"
          className={
            'min-h-tap-chip-lg w-full rounded-xl bg-card border-[1.5px] border-accent ' +
            'text-ink font-display text-h2 shadow-card flex flex-col items-center justify-center gap-2 ' +
            'opacity-50 disabled:active:opacity-50'
          }
          style={{ minHeight: 120 }}
        >
          <span>Умный фурнитурщик</span>
          <span className="text-ink text-base font-body opacity-70">
            Подбор фурнитуры по задаче
          </span>
          <span
            className="rounded-md px-2 py-0.5 text-sm font-body text-card"
            style={{ backgroundColor: BURGUNDY }}
          >
            Скоро заработает
          </span>
        </button>
      </div>

      <BottomBar />
    </main>
  );
}
